import React from 'react';
import { Card, CardContent } from './ui/card';
import { Plane, Ship, Home, Clock, User, Car } from 'lucide-react';
import { services } from '../mockData';

const iconMap = {
  Plane: Plane,
  Ship: Ship,
  Home: Home,
  Clock: Clock,
  User: User,
  Car: Car
};

const Services = () => {
  return (
    <section id="services" className="py-10 sm:py-16 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="text-blue-600">Services</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Comprehensive transfer solutions tailored to your needs across the beautiful island of Corfu
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3 sm:gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={index} 
                className="group hover:shadow-2xl transition-all duration-300 border-2 border-transparent hover:border-blue-500 bg-white overflow-hidden"
              >
                <CardContent className="p-4 sm:p-8">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-blue-500 to-cyan-400 rounded-2xl flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className="text-white" size={24} />
                  </div>
                  <h3 className="text-base sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                    {service.title}
                  </h3>
                  <p className="text-xs sm:text-base text-gray-600 leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Feature Image Section */}
        <div className="mt-20 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Why Choose Golden Corfu Transfer?
            </h3>
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-yellow-600 font-bold text-xl">✓</span>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Fixed Transparent Pricing</h4>
                  <p className="text-gray-600">No hidden fees, no surprises. All prices agreed upfront.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-yellow-600 font-bold text-xl">✓</span>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Professional Local Drivers</h4>
                  <p className="text-gray-600">Experienced drivers who know every corner of Corfu.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-yellow-600 font-bold text-xl">✓</span>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Modern Luxury Fleet</h4>
                  <p className="text-gray-600">Comfortable, air-conditioned vehicles maintained to perfection.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-yellow-600 font-bold text-xl">✓</span>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Flight Monitoring Service</h4>
                  <p className="text-gray-600">We track your flight and adjust pickup times automatically.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="aspect-square rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://customer-assets.emergentagent.com/job_corfu-rides/artifacts/btrcr8i1_WhatsApp%20Image%202026-05-12%20at%2016.55.31.jpeg" 
                alt="Golden Corfu Transfer Mercedes Vehicle"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Decorative Elements */}
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-gradient-to-br from-yellow-400 to-amber-500 rounded-full blur-3xl opacity-50"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-gradient-to-br from-blue-400 to-cyan-500 rounded-full blur-3xl opacity-50"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;